/* eslint-disable */
import axios from '@/services/axios'

export default {
    getVote2026DataDonutBar(search, source) {
        return axios.get("/vote/getVote2026DataDonutBar", { params: search, cancelToken: source.token });
    },
    getVote2026DataLine(search, source) {
        return axios.post("/vote/getVote2026DataLine", search, { cancelToken: source.token });
    },

    getVote2026CandidateList(search, source) {
        return axios.post("/vote/getVote2026CandidateList", search, { cancelToken: source.token });
    },

    getVote2026DataNet(search, source) {
        return axios.post("/vote/getVote2026DataNet", search, { cancelToken: source.token });
    },

    getVote2026RelationDataLine(search, source) {
        return axios.post("/vote/getVote2026RelationDataLine", search, { cancelToken: source.token });
    },









    getVoteDataStack(search, source) {
        return axios.get("/vote/getVoteDataStack", { params: search, cancelToken: source.token });
    },

    getVoteDataNet(search, source) {
        return axios.post("/vote/getVoteDataNet", search, { cancelToken: source.token });
    },

    getCandidateList(search, source) {
        return axios.post("/vote/getCandidateList", search, { cancelToken: source.token });
    },
    getVoteRelationDataLine(search, source) {
        return axios.post("/vote/getVoteRelationDataLine", search, { cancelToken: source.token });
    },
    
    

    // getCompetitionDataTable(search, source) {
    //     return axios.post("/competition/getCompetitionDataTable", search, { cancelToken: source.token });
    // },
    
};
